import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormsCircleSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="forms-circle-square, shapes, designs, templates"><path d="M19.25 8C20.2165 8 21 8.7835 21 9.75V19.25C21 20.2165 20.2165 21 19.25 21H9.75C8.7835 21 8 20.2165 8 19.25V17.4395C8.32808 17.4779 8.66159 17.5 9 17.5C13.6944 17.5 17.5 13.6944 17.5 9C17.5 8.66159 17.4779 8.32808 17.4395 8H19.25Z" fill="currentColor"/><path d="M9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormsCircleSquare;
